import changeStatePasswordInput from "../../js/changeStatePasswordInput"
import changeStateForm from "../../js/changeStateForm"
import WatcherStateForm from "../../js/watcherStateForm"
import Validate from "../../js/Validate"
import ValidateInput from "../../js/ValidateInput"

const validation = {
  email: null,
  password: null,
  checkbox: null,
}

export default function mainScript(events) {
  if (localStorage.getItem("cache")) window.location.href = 'https://wildwinz.com/'
  const configStateForInputsLabel = {
    phone: {
      default: "",
      error: "Invalid format",
      placeholder: ''
    },
    email: {
      default: "",
      error: "Invalid format",
      placeholder: ''
    },
    psw: {
      default: "",
      error: "Minimum 6 characters"
    }
  }
  let currentState = 'email'
  const stateValidate = {
    phone: Validate.isPhone,
    email: Validate.isEmail
  }
  const stateValidateInput = {
    phone: ValidateInput.phone,
    email: ValidateInput.default
  }
  const sendBtn = document.querySelector('#register')
  const googleBtn = document.querySelector('#Google')
  const tabPhone = document.querySelector('#tabPhone')
  const tabEmail = document.querySelector('#tabEmail')
  const label = document.querySelector('#register-contact-error')
  const contactInput = document.querySelector('#RegisterForm_contact')
  const mainBtn = document.querySelector('#register')
  const textForContact = document.querySelector('#register-contact-error')
  const textForPsw = document.querySelector('#register-password-error')

  tabPhone.addEventListener('click', (e) => {
    tabEmail.classList.remove('active')
    tabPhone.classList.add('active')
    initPhoneField($("#RegisterForm_contact"))
    currentState = 'phone'
    label.innerHTML = configStateForInputsLabel.phone.default
    changeStateForm('#email-state', "in-work")
    watcherStateForm.checkState()
    mainBtn.classList.add('disable')
    mainBtn.disabled = true
    textForContact.classList.remove('error')
  })
  tabEmail.addEventListener('click', (e) => {
    tabEmail.classList.add('active')
    tabPhone.classList.remove('active')
    removePhoneField($("#RegisterForm_contact"))
    currentState = 'email'
    label.innerHTML = configStateForInputsLabel.email.default
    contactInput.innerHTML = ''
    contactInput.setAttribute("placeholder", configStateForInputsLabel.email.placeholder)
    changeStateForm('#email-state', "in-work")
    watcherStateForm.checkState()
    mainBtn.classList.add('disable')
    mainBtn.disabled = true
    textForContact.classList.remove('error')
  })
  sendBtn.addEventListener('click', (e) => {
    e.preventDefault()
    remoteAuthorization(e, "wildwinz", [], "&redirectUrl=/#/cash/deposit/", !0)
    sendBtn.classList.add('loader')
  })
  googleBtn.addEventListener('click', (e) => {
    e.preventDefault()
    remoteLoginSocial(e, "wildwinz")
  })
  const watcherStateForm = new WatcherStateForm(['#email-state', '#password-state'], '#btn-state');
  changeStatePasswordInput('#RegisterForm_password', '#RegisterForm_password_change')
  contactInput.addEventListener('blur', () => {
    if (stateValidate[currentState](contactInput.value)) {
      changeStateForm('#email-state', "success")
      validation.email = true
    } else {
      validation.email = false
      changeStateForm('#email-state', "error-state")
      textForContact.innerHTML = configStateForInputsLabel[currentState].error
      textForContact.classList.add('error')
      contactInput.classList.add('error-input')
    }
    validateForm()
    watcherStateForm.checkState()
  })
  contactInput.addEventListener('keydown', (e) => {
    stateValidateInput[currentState](e, contactInput)
    textForContact.classList.remove('error')
    contactInput.classList.remove('error-input')
    setTimeout(() => {
      changeCurrentStateForm(contactInput.value)
    }, 10)
  })
  const pswInput = document.querySelector('#RegisterForm_password')
  pswInput.addEventListener('input', () => {
    if (Validate.psw(pswInput.value)) {
      changeStateForm('#password-state', "success")
      validation.password = true
    } else {
      validation.password = false
      changeStateForm('#password-state', "in-work")
      mainBtn.classList.add('disable')
      mainBtn.disabled = true
    }
    textForPsw.innerHTML = configStateForInputsLabel.psw.default
    textForPsw.classList.remove('error')
    pswInput.classList.remove('error-input')
    watcherStateForm.checkState()
    if (watcherStateForm.getFormIsValid()) {
      mainBtn.classList.remove('disable')
      mainBtn.disabled = false
    } else {
      mainBtn.classList.add('disable')
      mainBtn.disabled = true
    }
    validateForm()
  })
  pswInput.addEventListener('change', () => {
    if (Validate.psw(pswInput.value)) {
      changeStateForm('#password-state', "success")
      validation.password = true
    } else {
      validation.password = false
      changeStateForm('#password-state', "error-state")
      textForPsw.innerHTML = configStateForInputsLabel.psw.error
      textForPsw.classList.add('error')
      pswInput.classList.add('error-input')
    }
    watcherStateForm.checkState()
    validateForm()
  })
  function changeCurrentStateForm(str) {
    if (stateValidate[currentState](str)) {
      changeStateForm('#email-state', "success")
      watcherStateForm.checkState()
      if (!watcherStateForm.getIsSuccessStatusByKey('#password-state')) {
        changeStateForm('#password-state', "in-work")
      }
      if (watcherStateForm.getFormIsValid()) {
        mainBtn.classList.remove('disable')
        mainBtn.disabled = false
      } else {
        mainBtn.classList.add('disable')
        mainBtn.disabled = true
      }
    } else {
      changeStateForm('#email-state', "in-work")
      watcherStateForm.checkState()
      if (!watcherStateForm.getIsSuccessStatusByKey('#password-state')) {
        changeStateForm('#password-state', "not-active")
      }
      mainBtn.classList.add('disable')
      mainBtn.disabled = true
    }
    document.querySelector('#register-contact-error').innerHTML = configStateForInputsLabel[currentState].default
  }
  document.addEventListener("beforeSend", function () {
      return window.localStorage.setItem("cache", "cached")
    }),
    document.addEventListener("errorSend", function () {
      return window.localStorage.removeItem("cache")
    });
}


document.addEventListener('DOMContentLoaded', function () {
  var checkboxes = document.querySelectorAll('input[type="checkbox"]');
  var popupBtn = document.querySelector('.popup-btn');

  checkboxes.forEach(function (checkbox) {
    checkbox.addEventListener('change', function () {
      Array.from(checkboxes).every(function (cb) {
        validation.checkbox = cb.checked
        return cb.checked;
      });
      validateForm()
    });
  });

  // Initialize custom selects with Canada as default
  initializeCustomSelect(document.querySelector('.custom-select-wrapper'), 'country', true);
  initializeCustomSelect(document.querySelectorAll('.custom-select-wrapper')[1], 'currency', false);

  // Initialize province select
  initializeProvinceSelect();
});

function initializeCustomSelect(selectWrapper, hiddenInputId, isCountrySelect) {
  const customSelect = selectWrapper.querySelector('.custom-select');
  const selectTrigger = customSelect.querySelector('.select-trigger');
  const options = customSelect.querySelectorAll('.custom-option');
  const hiddenInput = document.getElementById(hiddenInputId);

  selectTrigger.addEventListener('click', () => {
    customSelect.querySelector('.custom-options').classList.toggle('active');
  });

  options.forEach(option => {
    option.addEventListener('click', () => {
      const value = option.dataset.value;
      const text = option.textContent.trim();
      hiddenInput.value = value;

      const selectTriggerSpan = selectTrigger.querySelector('span');
      if (isCountrySelect) {
        const imgSrc = option.querySelector('img').src;
        selectTriggerSpan.innerHTML = `<img src="${imgSrc}" alt="${text}" style="width: 20px; height: 20px; margin-right: 10px;">${text}`;

        updateCurrencyOptions(value);
        document.querySelector('input[name="RegisterForm[country_id]"]').value = getCountryId(value);

        if (value === 'canada') {
          document.getElementById('provinceContainer').style.display = 'block';
        } else {
          document.getElementById('provinceContainer').style.display = 'none';
          document.querySelector('input[name="RegisterForm[state]"]').value = '';
        }
      } else {
        selectTriggerSpan.textContent = text;
      }

      customSelect.querySelector('.custom-options').classList.remove('active');
      validateForm();
    });
  });

  document.addEventListener('click', (e) => {
    if (!customSelect.contains(e.target)) {
      customSelect.querySelector('.custom-options').classList.remove('active');
    }
  });

  // Set Canada as default for country select
  if (isCountrySelect) {
    const canadaOption = Array.from(options).find(opt => opt.dataset.value === 'canada');
    if (canadaOption) {
      canadaOption.click();
    }
  }
}

function initializeProvinceSelect() {
  const provinceContainer = document.getElementById('provinceContainer');
  const provinceTrigger = provinceContainer.querySelector('.select-trigger');
  const provinceOptions = provinceContainer.querySelector('.custom-options');
  const provinceOptionItems = provinceOptions.querySelectorAll('.custom-option');

  provinceTrigger.addEventListener('click', () => {
    provinceOptions.style.display = provinceOptions.style.display === 'block' ? 'none' : 'block';
  });

  provinceOptionItems.forEach(option => {
    option.addEventListener('click', () => {
      const value = option.dataset.value;
      const text = option.textContent.trim();
      provinceTrigger.querySelector('span').textContent = text;
      document.getElementById('province').value = value;
      document.querySelector('input[name="RegisterForm[state]"]').value = value;
      provinceOptions.style.display = 'none';
      validateForm();
    });
  });

  document.addEventListener('click', (e) => {
    if (!provinceContainer.contains(e.target)) {
      provinceOptions.style.display = 'none';
    }
  });
}

function updateCurrencyOptions(countryValue) {
  const currencySelect = document.querySelectorAll('.custom-select-wrapper')[1].querySelector('.custom-select');
  const currencyOptions = currencySelect.querySelector('.custom-options');
  const currencyTrigger = currencySelect.querySelector('.select-trigger span');
  const currencyHiddenInput = document.getElementById('currency');

  currencyOptions.innerHTML = '';

  let currencies = ['EUR'];

  switch(countryValue) {
    case 'australia':
      currencies = ['AUD'];
      break;
    case 'canada':
      currencies = ['CAD'];
      break;
    case 'new-zealand':
      currencies = ['NZD'];
      break;
    default:
      currencies = ['EUR'];
  }

  currencies.forEach(currency => {
    const li = document.createElement('li');
    li.className = 'custom-option';
    li.dataset.value = currency;
    li.textContent = currency;
    li.addEventListener('click', () => {
      currencyTrigger.textContent = currency;
      currencyHiddenInput.value = currency;
      currencySelect.querySelector('.custom-options').classList.remove('active');
      validateForm();
    });
    currencyOptions.appendChild(li);
  });

  currencyTrigger.textContent = currencies[0];
  currencyHiddenInput.value = currencies[0];

  document.querySelector('input[name="RegisterForm[currency_id]"]').value = getCurrencyId(currencies[0]);
}

function validateForm() {
  const country = document.getElementById('country').value;
  const currency = document.getElementById('currency').value;
  const countryError = document.getElementById('countryError');
  const currencyError = document.getElementById('currencyError');
  const provinceError = document.getElementById('provinceError');
  const mainBtn = document.querySelector('#register')

  let isValid = true;

  if (!country) {
    countryError.textContent = 'Please select a country';
    isValid = false;
  } else {
    countryError.textContent = '';
  }

  if (!currency) {
    currencyError.textContent = 'Please select a currency';
    isValid = false;
  } else {
    currencyError.textContent = '';
  }
  const provinceValue = document.getElementById('province').value;

  if (country === 'canada') {
    if (!provinceValue) {
      provinceError.textContent = 'Please select a province';
      isValid = false;
    } else {
      provinceError.textContent = '';
    }
  } else {
    provinceError.textContent = '';
  }

  /**
   * HOT CRUTCH
   */

  if(validation.email && validation.password && validation.checkbox){
    if(country === 'canada' && !provinceValue) {
      isValid = false;
      mainBtn.classList.add('disable')
      mainBtn.classList.add('checkbox-disabled')
      mainBtn.disabled = true
      return isValid
    }
    isValid = true;
    mainBtn.classList.remove('disable')
    mainBtn.classList.remove('checkbox-disabled')
    mainBtn.disabled = false
    return isValid
  } else {
    isValid = false;
    mainBtn.classList.add('disable')
    mainBtn.classList.add('checkbox-disabled')
    mainBtn.disabled = true
  }


  return isValid;

  return isValid;
}

function getCountryId(countryValue) {
  const countryMap = {
    'australia': '505',
    'slovakia': '502',
    'croatia': '490',
    'italy': '495',
    'hungary': '492',
    'canada': '477',
    'belgium': '481',
    'switzerland': '504',
    'slovenia': '501',
    'luxembourg': '498',
    'liechtenstein': '497',
    'austria': '480',
    'iceland': '494',
    'norway': '499',
    'finland': '487',
    'ireland': '493',
    'czech-republic': '484',
    'germany': '489',
    'spain': '503',
    'poland': '479',
    'portugal': '500',
    'greece': '491',
    'latvia': '496',
    'new-zealand': '478'
  };
  return countryMap[countryValue] || '';
}

function getCurrencyId(currencyValue) {
  const currencyMap = {
    'EUR': '11',
    'CAD': '10',
    'AUD': '14',
    'NZD': '13'
  };
  return currencyMap[currencyValue] || '';
}

document.addEventListener('scroll', (event) => {
  if (window.scrollY + window.innerHeight >= document.body.offsetHeight) {
    event.preventDefault();
  }
});